import React from 'react';

import { PrimaryButton } from 'src/components/common/buttons/PrimaryButton';
import { IEmptySiteStateProps } from 'src/features/site/domain/types';
import WithRoleAccess from 'src/routes/WithRoleAccess';

export const EmptySiteState: React.FC<IEmptySiteStateProps> = ({
	onCreateSite,
}) => {
	return (
		<section
			style={{ padding: '24px 24px 50px 24px' }}
			className='flex overflow-hidden flex-col items-center mt-6 w-full bg-white rounded-md'
		>
			<header className='flex items-center w-full text-xl tracking-wide leading-none whitespace-nowrap'>
				<h1 className='self-stretch my-auto'>
					<span className='self-stretch'>Sites</span>
				</h1>
			</header>
			<div className='flex flex-col items-center mt-6 w-full tracking-normal leading-6'>
				<WithRoleAccess
					allowedGlobalRoles={['super_admin']}
					fallBackChildren={
						<h2 className='self-stretch text-2xl leading-none text-center w-full'>
							You don’t have access to any sites yet.
						</h2>
					}
				>
					<h2 className='self-stretch text-2xl leading-none text-center w-full'>
						Create your first site
					</h2>
				</WithRoleAccess>
				<p
					className='mt-3.5 text-base text-center w-full'
					style={{ color: 'rgba(0, 0, 0, 0.38)' }}
				>
					Welcome to our platform, a workspace designed for seamless
					collaboration with your teams, managing Sites,
					<br /> tracking progress, assigning annotators, and adding
					annotations to ensure efficient study management.
				</p>
				<WithRoleAccess allowedGlobalRoles={['super_admin']}>
					<PrimaryButton
						onClick={onCreateSite}
						sx={{
							marginTop: '14px',
							width: '183px',
							height: '36px',
							textTransform: 'uppercase',
							fontSize: '14px',
							fontWeight: 500,
							letterSpacing: '0.5px',
							backgroundColor: '#BE3327',
							'&:hover': {
								backgroundColor: '#A52D23',
							},
						}}
					>
						CREATE NEW SITE
					</PrimaryButton>
				</WithRoleAccess>
			</div>
		</section>
	);
};

export default EmptySiteState;
